import { render } from "./Hanjiadd.vue?vue&type=template&id=1f22fdfe&scoped=true"
import script from "./Hanjiadd.vue?vue&type=script&lang=js"
export * from "./Hanjiadd.vue?vue&type=script&lang=js"

import "./Hanjiadd.vue?vue&type=style&index=0&id=1f22fdfe&scoped=true&lang=scss"

import exportComponent from "D:\\peizhe_protal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f22fdfe"]])

export default __exports__